import React, { useContext, useState } from 'react'
import {
  Card,
  Button,
  Form,
  InputGroup,
  Row,
  Col,
  Container,
} from 'react-bootstrap'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { AuthContext } from '../../AuthContext'
import Cookies from 'js-cookie'

const AddWater = ({ onSuccess, onCancel, date }) => {
  const { patient_id } = useParams()
  const { baseUrl, currentUser, extendCookie, setLoginShow } =
    useContext(AuthContext)
  const sessionFromCookie = Cookies.get('session')
  const { session = '' } = sessionFromCookie
    ? JSON.parse(sessionFromCookie)
    : {}

  const [records, setRecords] = useState([
    {
      time: '',
      amount: '',
      comment: '',
    },
  ])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errors, setErrors] = useState({})

  // 添加新的一筆記錄欄位
  const handleAddNewRow = () => {
    setRecords((prev) => [
      ...prev,
      {
        time: '',
        amount: '',
        comment: '',
      },
    ])
  }

  // 處理輸入變更
  const handleInputChange = (index, field, value) => {
    setRecords((prev) =>
      prev.map((record, i) =>
        i === index ? { ...record, [field]: value } : record
      )
    )

    // 清除該欄位的錯誤訊息
    if (errors[`${field}_${index}`]) {
      setErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors[`${field}_${index}`]
        return newErrors
      })
    }
  }

  // 驗證表單
  const validateForm = () => {
    const newErrors = {}
    let isValid = true

    records.forEach((record, index) => {
      if (!record.time) {
        newErrors[`time_${index}`] = '請輸入時間'
        isValid = false
      }
      if (!record.amount) {
        newErrors[`amount_${index}`] = '請輸入喝水量'
        isValid = false
      } else {
        const amountValue = parseInt(record.amount)
        if (isNaN(amountValue) || amountValue <= 0 || amountValue > 3000) {
          newErrors[`amount_${index}`] = '喝水量異常'
          isValid = false
        }
      }
    })

    setErrors(newErrors)
    return isValid
  }

  // 提交新記錄
  const handleSubmit = async () => {
    if (!session) {
      setLoginShow(true)
      return
    }

    if (!validateForm()) return

    try {
      setIsSubmitting(true)

      // 格式化數據
      const water = records.map((record) => ({
        amount: parseInt(record.amount),
        comment: record.comment || '',
        record_time: `${date} ${record.time}:00`,
      }))

      const response = await axios.post(
        `${baseUrl}/api/crm/patient/measure/addWater`,
        {
          patient_id,
          water,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
            session: currentUser?.session || session || '',
          },
        }
      )

      if (response.data.message === '新增成功') {
        onSuccess?.()
        extendCookie()
      } else if (response?.data?.error?.code === '50004') {
        setLoginShow(true)
        throw new Error('Session expired')
      }
    } catch (error) {
      console.error('Error adding water records:', error)
      setErrors({ submit: '新增記錄失敗，請稍後再試' })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Container className="py-4">
      <div className="mb-4">
        <Button
          variant="link"
          onClick={onCancel}
          className="text-decoration-none text-secondary"
        >
          <h5>
            <i className="fa-solid fa-arrow-left me-2" />
            返回數據收集紀錄
          </h5>
        </Button>
      </div>

      <Card className="position-relative mb-4 rounded-3 p-4">
        {/* 日期和按鈕區域 */}
        <div className="d-flex justify-content-between align-items-center">
          <h4 className="m-0">{date}</h4>
          <div>
            <Button
              variant="outline-primary"
              className="me-2"
              onClick={onCancel}
              disabled={isSubmitting}
            >
              取消
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? '儲存中...' : '儲存'}
            </Button>
          </div>
        </div>

        {/* 記錄輸入區域 */}
        {records.map((record, index) => (
          <Row key={index} className="mt-3 g-3">
            <Col md={3}>
              <Form.Group>
                <Form.Control
                  type="time"
                  value={record.time}
                  onChange={(e) =>
                    handleInputChange(index, 'time', e.target.value)
                  }
                  isInvalid={!!errors[`time_${index}`]}
                  placeholder="00:00"
                />
                <Form.Control.Feedback type="invalid">
                  {errors[`time_${index}`]}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <InputGroup hasValidation>
                  <Form.Control
                    type="text"
                    placeholder="喝水量"
                    value={record.amount}
                    onChange={(e) =>
                      handleInputChange(index, 'amount', e.target.value)
                    }
                    isInvalid={!!errors[`amount_${index}`]}
                  />
                  <InputGroup.Text>cc</InputGroup.Text>
                  <Form.Control.Feedback type="invalid">
                    {errors[`amount_${index}`]}
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Control
                placeholder="備註可留空"
                value={record.comment}
                onChange={(e) =>
                  handleInputChange(index, 'comment', e.target.value)
                }
              />
            </Col>
          </Row>
        ))}

        {/* 新增一筆按鈕 */}
        <div className="d-flex justify-content-center mt-3">
          <Button
            variant="primary"
            className="text-white text-decoration-none"
            onClick={handleAddNewRow}
            disabled={isSubmitting}
          >
            + 新增一筆
          </Button>
        </div>
      </Card>

      {errors.submit && (
        <div className="text-danger text-center mt-2">{errors.submit}</div>
      )}
    </Container>
  )
}

export default AddWater
